import { memo, type ReactNode } from 'react'

import { SubSectionTitle } from '@/components/common/SubSectionTitle'

interface VaultListingLayoutProps {
  children: ReactNode
}

function VaultListingLayout({ children }: VaultListingLayoutProps) {
  return (
    <div className="gap-sm flex h-[100%] w-[100%] flex-col">
      <SubSectionTitle>Vaults Listing The Market</SubSectionTitle>
      {children}
    </div>
  )
}

export default memo(VaultListingLayout)
